export function removeNode (el = {}) {
  var parent = el.parentNode

  if (parent) {
    parent.removeChild(el)
  }
}



// WEBPACK FOOTER //
// ./src/components/confirm/utils.js